<!-- 地块图形 -->
<template>
  <div class="map-land-feature">
    <LVector :defaultStyle="defaultStyle" :selectStyle="selectStyle" :selectKeys="selectKeys" :zIndex="10"
      :selectFeature="selectFeature" eventShow ref="LVector">
      <LCircleFeature :center="[item.longitude, item.latitude]" v-for="(item, index) in circleList"
        :id="`${item[idKey] ? item[idKey] : index}`" :key="'circle_' + index"></LCircleFeature>
      <LPolygonFeature :positions="item.coordinates" :id="`${item[idKey] ? item[idKey] : index}`"
        v-for="(item, index) in polygonList" :key="'polygon_' + index"></LPolygonFeature>
    </LVector>
  </div>
</template>

<script>
import { LVector, LCircleFeature, LPolygonFeature, OMapMixin } from '@OpenLayersCommon';
import { Fill, Style, Stroke, Icon } from 'ol/style';

export default {
    name: 'LandFeature',
    mixins: [OMapMixin],
    components: {
        LCircleFeature,
        LVector,
        LPolygonFeature,
    },
    props: {
        rangeData: {
            // 地块范围数组 [{}]
            type: Array,
            default () {
                return [];
            },
        },
        defaultStyle: {
            // feature 默认样式
            type: Object,
            default () {
                return { fill: { color: 'rgba(73,240,253,0.5)' }, stroke: { color: '#49F0FD', width: 1 } };
            },
        },
        selectStyle: {
            // feature 默认选择样式
            type: Object,
            default () {
                return { fill: { color: 'rgba(73,240,253,0.5)' }, stroke: { color: '#49F0FD' } };
            },
        },
        idKey: {
            // feature id的 key
            type: String,
            default: 'id',
        },
    },
    data () {
        return {
            selectKeys: [],
            flashInterval: null,
            flashSpeed: 2,
            flashStyle1: {
                stroke: {
                    color: 'red',
                    width: 2,
                    lineDash: [3, 5],
                },
                fill: {
                    color: 'rgba(255, 255, 0, 0.3)',
                },
            },
            flashingFeature: '', // 当前闪烁的feature
        };
    },

    computed: {
        circleList () {
            let list = [];
            let rangeData = this.rangeData;
            rangeData.forEach((item) => {
                let type = item.type;
                if (type === 'circle') {
                    item.scope = item.radius;
                    list.push(item);
                    item.scope = item.radius;
                }
            });
            return list;
        },
        polygonList () {
            let list = [];
            let rangeData = this.rangeData;
            rangeData.forEach((item) => {
                let type = item.type;
                if (type === 'polygon' || type === 'rectangle') {
                    let points = item.points || [];
                    let coordinates = [];
                    let positions = [];
                    if (type === 'rectangle') {
                        // 当是矩形的时候如果数据只有2个点要计算另外两个对角点
                        if (points.length === 2) {
                            let p1 = points[0];
                            let p2 = points[1];
                            let p3 = {
                                longitude: p2.longitude,
                                latitude: p1.latitude,
                            };
                            let p4 = {
                                longitude: p1.longitude,
                                latitude: p2.latitude,
                            };
                            let newPoints = [p1, p3, p2, p4];
                            points = newPoints;
                        }
                    }
                    points.forEach((p) => {
                        let { latitude, longitude } = p;
                        if (latitude && longitude) {
                            positions.push([longitude, latitude]);
                        }
                    });
                    coordinates.push(positions);
                    item.coordinates = coordinates;
                    list.push(item);
                }
            });
            return list;
        },
    },
    methods: {
        selectFeature (e, id, feature) {
            console.log(id);
            // let style = this.getStyle(this.selectStyle);
            // feature.setStyle(style);
            // this.setFlash(feature);
            this.$emit('selectFeature', id);
        },
        setFlash (feature) {
            let self = this;
            if (!feature) return;
            let flashCount = 0; // 闪烁次数
            const flashStyle1 = this.getStyle(this.flashStyle1);

            const defaultStyle = this.getStyle(this.defaultStyle);
            let speed = this.flashSpeed;
            if (this.flashInterval) {
                clearInterval(this.flashInterval);
                this.flashInterval = null;
                if (this.flashingFeature) {
                    this.flashingFeature.setStyle(defaultStyle);
                }
            }
            this.flashingFeature = feature;

            this.flashInterval = setInterval(() => {
                if (flashCount <= 20) {
                    if (flashCount % 2 === 0) {
                        feature.setStyle(flashStyle1);
                    } else {
                        feature.setStyle(defaultStyle);
                    }
                    flashCount++;
                } else {
                    feature.setStyle(defaultStyle);
                    clearInterval(self.flashInterval);
                    this.flashInterval = null;
                    this.flashingFeature = '';
                }
            }, speed * 100);
        },
        /**
     * 通过ID查找feature
     */
        selectFeatureById (id) {
            if (this.$refs.LVector) {
                let feature = this.$refs.LVector.getFeatureById(id);

                this.setFlash(feature);
            }
        },
        getStyle (obj) {
            let result = {};
            if (obj.stroke) {
                result.stroke = new Stroke(obj.stroke);
            }
            if (obj.fill) {
                result.fill = new Fill(obj.fill);
            }
            if (obj.imgUrl) {
                result.image = new Icon({
                    src: obj.imgUrl,
                    anchor: [0, 0],
                });
            }
            return new Style(result);
        },
    },
    created () { },
    mounted () { },
    watch: {
        rangeData (val) {
            // console.log(val);
        },
    },
};
</script>

<style lang="scss" scoped>

</style>
